import React from 'react';
import { Slide } from '@progress/kendo-react-animation';
import { hideMsg } from './utils/logger';
import { connect } from 'react-redux';
import AlertDialog from './dialogs/AlertDialog';
import './Alert.scss';

let _timers = [];

/**
 * Alert component
 */
const Alert = (props) => {
  const alertMsgs = props.msgs.filter(x => !x.isDialog).map((msg) => {
    if (!_timers.find(x => x.messageId === msg.messageId)) {
      _timers = [
        ..._timers,
        {
          messageId: msg.messageId,
          timer: setTimeout(() => {
            props.hideMsg(msg);
            _timers = _timers.filter(x => x.messageId !== msg.messageId);
          }, 8000)
        }
      ];
    }
    return msg;
  });
  const dialogMsgs = props.msgs.filter(x => x.isDialog);

  return (
    <>
      {dialogMsgs.map((msg, i) =>
        <AlertDialog
          key={i}
          title={msg.title ? msg.title : (msg.messageType === "error" ? "Chyba" : (msg.messageType === "warning" ? "Upozornenie" : "Oznámenie"))}
          isOpen={true}
          onEsc={() => props.hideMsg(msg)}
          onClose={() => props.hideMsg(msg)}
          text={msg.message}
          level={i}
          className={"alert-" + msg.messageType}
        />
      )}
      <Slide className="alert-container" direction={'up'} key="alertContainer" enter={alertMsgs.length === 1}>
        {alertMsgs.map((msg, i) =>
          <div className={'alert alert-' + msg.messageType} key={i}>
            {msg.message.split(/\n|\\n/).map((x, index) => (<React.Fragment key={index}>{x}<br /></React.Fragment>))}
            <button type="button" className="close"
              onClick={() => props.hideMsg(msg)}
              data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>)}
      </Slide>
    </>
  );
}

const mapStateToProps = state => ({
  msgs: state.loggerReducer.msg
});

const mapDispatchToProps = dispatch => ({
  hideMsg: (msg) => dispatch(hideMsg(msg))
});

export default connect(mapStateToProps, mapDispatchToProps)(Alert);